export class ValidatorService {
  static isMin(value, min) {
    if (value.trim().length < min) {
      return `Ce champ doit comporter au moins ${min} lettres`;
    } else return "";
  }
  static isMax(value, max) {
    if (value.trim().length > max) {
      return `Ce champ doit comporter au plus ${max} lettres`;
    } else return "";
  }

  static isEmailCorrect(value) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(value.trim())) {
      return "Veuillez entrer une adresse email valide";
    } else return "";
  }

  static isPhoneCorrect(value) {
    const phonePattern = /^0[1-68]([-. ]?[0-9]{2}){4}$/;
    if (
      value != null &&
      value.trim() !== "" &&
      !phonePattern.test(value.trim())
    ) {
      return "Veuillez entrer un numéro de téléphone valide";
    } else return "";
  }
}
